<template>
  <button type="button" class="btn-default my-button" :class="cClass"  @click="onClick">
    <span><slot></slot></span>
  </button>
</template>

<script>
export default {
  created () {

  },
  props: {
    disable:Boolean
  },
  data() {
    return {
      disableShow:this.disable
    }
  },
  watch: {
    disable(val){
      this.disableShow = val
    }
  },
  computed: {
    cClass () {
      const arr = ['my-button--' + this.type]
      if (this.disableShow == true) {
        arr.push('is-disabled')
      }
      return arr
    }
  },
   methods: {
    onClick () {
      if (this.disableShow == false) {
        if (this.$listeners.click) {
          this.$listeners.click()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.my-button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  color: #525250;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  transition: 0.1s;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  padding: 10px 20px;
  font-size: 13px;
  border-radius: 8px;
  width: 188px;
  height: 40px;
  background-color: #F2F2ED;
  border: 0;
  box-shadow: -2px -2px 4px #fff,
              4px 4px 4px #E6E6E1;

  &:focus,
  &:hover {
      opacity: 0.6;
  }
  &.is-disabled {
      color: #B8B8B4 !important;
      background-color: #F2F2ED;
      cursor: default;
  }
  &.is-plain:hover {
    background: #fff;
    border-color: #409eff;
    color: #409eff;
    &.is-disabled {
      color: #c0c4cc;
      cursor: not-allowed;
      background-image: none;
      background-color: #fff;
      border-color: #ebeef5;
    }
  }
  & + .my-button {
    margin-left: 20px;
  }
}
</style>
